<template>
  <div>
    <v-row v-if="tasks.length">
      <v-col
        v-for="(task, index) in tasks"
        :key="task.uid"
        :ref="'task-col-' + task.uid"
        :cols="cols.cols"
        :sm="cols.sm * (task.numberOfSubTasks || 1)"
        :md="cols.md * (task.numberOfSubTasks || 1)"
        :lg="cols.lg * (task.numberOfSubTasks || 1)"
      >
        <v-lazy
          :options="{
          rootMargin: '500px'
        }"
          transition="fade-transition"
        >
          <component :is="CardComponent" :index="index" :task="task" :selected-assignee="selectedAssignee" :selected-edit-style="selectedEditStyle" v-bind="cardProps" />
        </v-lazy>
      </v-col>
    </v-row>
    <NoResults v-else />
  </div>
</template>

<script>
import NoResults from "@/components/NoResults";
import { EventBus } from "../../event-bus";
export default {
  name: "CardsGrid",
  components: { NoResults },
  mounted() {
    // Review-Flow: Nach Abschluss eines Tasks direkt den nächsten öffnen.
    // Nur das Grid reagiert, das den abgeschlossenen Task enthält.
    this._onTaskDone = (finishedUid) => {
      const index = this.tasks.findIndex((task) => task.uid === finishedUid);
      if (index === -1) return;
      const next = this.tasks[index + 1];
      if (!next) return;
      // Erst hinscrollen (v-lazy mountet die Karte), dann öffnen
      const col = this.$refs["task-col-" + next.uid];
      const el = Array.isArray(col) ? col[0]?.$el || col[0] : col?.$el || col;
      if (el?.scrollIntoView) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      setTimeout(() => {
        EventBus.$emit("live-editor-open-task", next.uid);
      }, 600);
    };
    EventBus.$on("live-editor-task-done", this._onTaskDone);
  },
  beforeDestroy() {
    EventBus.$off("live-editor-task-done", this._onTaskDone);
  },
  props: {
    CardComponent: {
      required: true,
    },
    selectedAssignee: { // Declare the selectedAssignee prop
      type: Object,
      default: () => ({}),
    },
    selectedEditStyle: {
      type: Object,
      default: () => ({}),
    },
    tasks: {
      type: Array,
      required: true,
    },
    /** Zusätzliche Props für die Karte (z. B. { reimport: true } in der Review-Ansicht) */
    cardProps: {
      type: Object,
      default: () => ({}),
    },
    cols: {
      default: function () {
        return {
          cols: "12",
          sm: "6",
          md: "4",
        };
      },
    },
  },
};
</script>

<style scoped></style>
